(ns com.theplantscape.plant-web.components.hero)

(defn hero-style-01 [{:keys [title description call-to-action-text call-to-action-link image body]}]
  [:section#hero {:class "relative h-screen flex items-center justify-center bg-cover bg-center bg-[url('http://localhost:8090/images/hero/hero-01.png')]"}
   [:div.absolute.inset-0.bg-black.opacity-40]
   [:div.relative.z-10.text-center.text-white.p-4
    [:h1.font-serif.text-5xl.md:text-7xl.font-bold.mb-6.drop-shadow-lg title #_"Transform Your Space with Living Art"]
    [:p.text-lg.md:text-2xl.mb-8.max-w-2xl.mx-auto.drop-shadow-md description #_"Bespoke plantscaping solutions to breathe life and beauty into your environment."]
    [:a.font-semibold.rounded-lg.focus:outline-none.focus:ring-2.focus:ring-offset-2.transition-all.duration-300.ease-in-out.inline-flex.items-center.justify-center.bg-brand-green.hover:bg-brand-green-dark.text-white.focus:ring-brand-green-dark.px-8.py-3.text-lg
     {:href call-to-action-link} call-to-action-text #_"Explore Our Designs"]
    body]])
